import type { RichEditorPreset } from '@odo/shared-ui';
import { toDoc } from './docBuilders';
import { filled, type VcaNoteFields } from './noteFields';

export function retentionNotesPreset(fields: VcaNoteFields): RichEditorPreset {
    const f = filled(fields);
    const doctor = fields.doctorLastName?.trim() || '_____';
    return {
        id: 'retention-template',
        label: 'Retention template',
        description: 'Doctor, patient and current aligner filled in; edit the rest.',
        doc: toDoc([
            [
                [`Hello Dr. ${doctor},`],
                [
                    `${f.patientFirstName} is approaching the end of their aligner set and is ready to be scheduled for a Removal and Retention appointment.`
                ],
                ['Please follow the Retention Scan Submission Checklist.'],
                [
                    { bold: 'Aligner Status:' },
                    ` current aligner ${f.aligner}; aligners [#–#] passive.`
                ],
                [{ bold: 'Patient Treatment Feedback: [insert message from the patient]' }],
                [{ bold: 'Ortho Notes: [if any]' }],
                [
                    'Important: once the patient reaches their last active or final aligner, DM will be paused.'
                ],
                ['Thank you!']
            ]
        ])
    };
}
